var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGaurd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_5261103",
    clipPath: "url(#clip0_3130_239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4587 0H23.4775C23.046 0 22.6963 0.349766 22.6963 0.78125C22.6963 1.21273 23.046 1.5625 23.4775 1.5625H33.4587C34.8877 1.5625 36.0502 2.72508 36.0502 4.15398V35.8459C36.0502 37.2749 34.8877 38.4374 33.4587 38.4374H6.54273C5.11375 38.4374 3.95117 37.2748 3.95117 35.8459V4.15406C3.95117 2.72508 5.11375 1.5625 6.54273 1.5625H16.6031C17.0346 1.5625 17.3844 1.21273 17.3844 0.78125C17.3844 0.349766 17.0346 0 16.6031 0H6.54273C4.25219 0 2.38867 1.86352 2.38867 4.15406V35.8459C2.38867 38.1365 4.25219 40 6.54273 40H33.4587C35.7492 40 37.6127 38.1365 37.6127 35.846V4.15398C37.6127 1.86352 35.7492 0 33.4587 0Z",
    fill: "url(#paint0_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2241 7.5751V12.2125C13.4505 11.5678 12.4859 11.217 11.468 11.217C11.0365 11.217 10.6867 11.5667 10.6867 11.9982V17.9567C10.5515 23.0668 14.843 27.5428 19.9665 27.5445C25.1086 27.5445 29.3908 23.0318 29.2463 17.9107V9.73721C29.2463 8.38947 28.1522 7.29291 26.8072 7.29291H26.7923C26.483 7.29291 26.1868 7.35096 25.9142 7.45674C25.869 6.10947 24.8363 5.10486 23.4767 5.10486C23.1508 5.10486 22.8397 5.16924 22.5552 5.28588C22.3366 4.1158 21.3328 3.25635 20.0917 3.25635C18.8747 3.25635 17.8576 4.12986 17.6319 5.284C17.3433 5.17049 17.0247 5.10869 16.6859 5.10869C15.3285 5.10885 14.2241 6.21518 14.2241 7.5751ZM17.5851 7.5751C17.5851 7.61494 17.585 15.2621 17.585 15.2621C17.585 15.6935 17.9347 16.0433 18.3662 16.0433C18.7977 16.0433 19.1475 15.6935 19.1475 15.2621L19.1476 5.76814C19.1476 5.24471 19.5711 4.81893 20.0916 4.81893C20.6394 4.81893 21.0369 5.21814 21.0369 5.76814L21.0355 15.0277C21.0355 15.4592 21.3853 15.8089 21.8168 15.8089C22.2483 15.8089 22.598 15.4592 22.598 15.0277C22.598 15.0277 22.5994 7.55838 22.5994 7.54916C22.5994 7.06291 22.993 6.66736 23.4767 6.66736C23.9928 6.66736 24.3533 7.02994 24.3533 7.54916L24.353 15.2621C24.353 15.6935 24.7028 16.0433 25.1343 16.0433C25.5658 16.0433 25.9155 15.6935 25.9155 15.2621C25.9155 15.2621 25.9158 9.77744 25.9158 9.73721C25.9158 9.25096 26.309 8.85541 26.7923 8.85541H26.8072C27.2906 8.85541 27.6838 9.25096 27.6838 9.73721V17.8983C27.5883 22.16 24.4262 25.982 19.9668 25.982C15.6095 25.9805 12.2492 22.208 12.2492 17.9674V12.8917C12.6855 13.0204 13.0855 13.2574 13.4163 13.5889C13.8355 14.0093 14.2173 15.1854 14.2238 16.0687V17.915C14.2238 18.3038 14.5057 18.6328 14.8906 18.6878C14.9743 18.7007 16.9497 19.0242 17.8394 20.9071C17.9729 21.1894 18.2535 21.3547 18.5463 21.3547C18.6581 21.3547 18.7717 21.3306 18.8795 21.2796C19.2697 21.0953 19.4365 20.6296 19.2522 20.2395C18.3614 18.3543 16.7117 17.5932 15.7863 17.3042L15.7866 7.57518C15.7866 7.07682 16.1901 6.67135 16.6859 6.67135C17.3496 6.67135 17.5851 7.15814 17.5851 7.5751Z",
    fill: "url(#paint1_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.4082 29.4067C22.9767 29.4067 22.627 29.7565 22.627 30.188V35.3101C22.627 36.1017 23.4041 36.0961 23.9456 36.0961C24.222 36.0961 24.6222 36.0946 25.2077 36.0913C25.6391 36.0889 25.987 35.7372 25.9845 35.3057C25.9821 34.8757 25.6328 34.5288 25.2034 34.5288C25.2019 34.5288 25.2004 34.5288 25.1989 34.5288C24.8558 34.5308 24.4944 34.5322 24.1895 34.5328V30.188C24.1895 29.7565 23.8397 29.4067 23.4082 29.4067Z",
    fill: "url(#paint2_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.4831 36.0956C12.9146 36.0956 13.2644 35.7459 13.2644 35.3144V30.188C13.2644 29.7565 12.9146 29.4067 12.4831 29.4067C12.0516 29.4067 11.7019 29.7565 11.7019 30.188V31.8821H9.7168V30.188C9.7168 29.7565 9.36703 29.4067 8.93555 29.4067C8.50406 29.4067 8.1543 29.7565 8.1543 30.188V35.3144C8.1543 35.7459 8.50406 36.0956 8.93555 36.0956C9.36703 36.0956 9.7168 35.7459 9.7168 35.3144V33.4446H11.7019V35.3144C11.7019 35.7459 12.0516 36.0956 12.4831 36.0956Z",
    fill: "url(#paint3_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.062 35.2966C27.0889 35.6575 27.4698 36.0197 27.8432 36.0197C27.8858 36.0195 28.8915 36.0156 29.2939 36.0086C30.8789 35.9809 32.0293 34.6109 32.0293 32.751C32.0293 30.7959 30.908 29.4824 29.2391 29.4824H27.8301C27.3938 29.4824 27.0488 29.8354 27.0488 30.2688C27.0489 30.2688 27.0538 35.2514 27.062 35.2966ZM29.2391 31.0449C30.3783 31.0449 30.4668 32.3508 30.4668 32.751C30.4668 33.5844 30.0957 34.4319 29.2666 34.4463C29.1144 34.449 28.8661 34.4512 28.6188 34.453C28.617 33.8794 28.6138 31.6429 28.6127 31.0449H29.2391Z",
    fill: "url(#paint4_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.6055 32.7512C14.6055 34.5953 16.1058 36.0956 17.9499 36.0956C19.7941 36.0956 21.2944 34.5953 21.2944 32.7512C21.2944 30.9071 19.7941 29.4067 17.9499 29.4067C16.1058 29.4067 14.6055 30.9071 14.6055 32.7512ZM19.7319 32.7512C19.7319 33.7338 18.9325 34.5331 17.9499 34.5331C16.9673 34.5331 16.168 33.7338 16.168 32.7512C16.168 31.7686 16.9673 30.9692 17.9499 30.9692C18.9325 30.9692 19.7319 31.7686 19.7319 32.7512Z",
    fill: "url(#paint5_linear_3130_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.4019 1.07985C19.5278 1.38688 19.8498 1.58594 20.1809 1.56016C20.5137 1.53422 20.799 1.295 20.8809 0.971096C21.0488 0.306955 20.3051 -0.234685 19.7221 0.111877C19.3944 0.306565 19.2553 0.727971 19.4019 1.07985Z",
    fill: "url(#paint6_linear_3130_239)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3130_239",
    x1: 20.0007,
    y1: 0,
    x2: 20.0007,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3130_239",
    x1: 19.9667,
    y1: 3.25635,
    x2: 19.9667,
    y2: 27.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3130_239",
    x1: 24.3057,
    y1: 29.4067,
    x2: 24.3057,
    y2: 36.0961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3130_239",
    x1: 10.7093,
    y1: 29.4067,
    x2: 10.7093,
    y2: 36.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3130_239",
    x1: 29.5391,
    y1: 29.4824,
    x2: 29.5391,
    y2: 36.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3130_239",
    x1: 17.9499,
    y1: 29.4067,
    x2: 17.9499,
    y2: 36.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3130_239",
    x1: 20.1244,
    y1: 0.00390625,
    x2: 20.1244,
    y2: 1.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B520F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3130_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaurd);
export default __webpack_public_path__ + "static/media/gaurd.bff0655205617666775700d6fe4176e9.svg";
export { ForwardRef as ReactComponent };